import { Avatar, Box, Button, Flex, Stack, Text } from "@chakra-ui/react";
import { PhoneIcon } from "@chakra-ui/icons";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { greetings, possessiveNoun } from "../utils/functions";
import Icon, { XButton } from "./ui-elements/Icon";
// import { WhatsAppIcon } from "../icons";

type Props = {
  assignedSupport: any;
  tutorInfo: any;
  requestSLUG: string;
  clientName: string;
};

const ChatWithSupport = observer(
  ({
    assignedSupport: { contactPhone, contactPhoto, contactName },
    tutorInfo,
    requestSLUG,
    clientName,
    ...rest
  }: Props) => {
    const callTimeStart = 8;
    const callTimeEnd = 18; //6:00pm
    const currentTime = new Date().getHours();
    const hidePhoneSupport =
      currentTime < callTimeStart || currentTime > callTimeEnd;

    const text = `Hello ${contactName}, I'll like to make an enquiry about ${possessiveNoun(
      clientName,
    )} request (Id: ${requestSLUG})`;

    const whatsAppChat = `https://wa.me/${contactPhone}?text=${encodeURI(
      text,
    )}`;

    return (
      <Stack align="center" {...rest}>
        <Avatar size="lg" name={contactName} src={contactPhoto} />
        <Box alignSelf="center" textAlign="center">
          <Text fontWeight="bold">{contactName}</Text>
          <Text opacity={0.8} fontSize="sm">
            Learning Support
          </Text>
        </Box>

        <Text mt={2} textAlign="center" width={["100%", "85%"]}>
          {greetings(currentTime)} {tutorInfo.firstName}! If you need to make an
          enquiry or clarify anything about {possessiveNoun(clientName)}{" "}
          request, please contact me and I'll do my best to help!
        </Text>

        <Text
          px={2}
          mt={2}
          fontWeight="medium"
          py={1}
          bg="gold.100"
          rounded="lg"
          fontSize="sm"
        >
          RequestID: {requestSLUG}
        </Text>

        <Flex
          direction={["column-reverse", "row"]}
          width="100%"
          mt={[6, 8]}
          mb={5}
        >
          {!hidePhoneSupport && (
            <Button
              mr={[0, 5]}
              as="a"
              href={`tel:${contactPhone}`}
              leftIcon={<PhoneIcon />}
              variant="outline"
              isFullWidth
              size="lg"
              target="_blank"
            >
              Call
            </Button>
          )}

          <XButton
            as="a"
            href={whatsAppChat}
            size="lg"
            target="_blank"
            isFullWidth
            colorScheme="whatsapp"
            leftIcon={"whatsapp"}
            mb={[3, 0]}
          >
            Chat
          </XButton>
        </Flex>
      </Stack>
    );
  },
);

export default ChatWithSupport;
